import * as React from "react";
import type { SVGProps } from "react";
const YoutubeBlack = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={24}
    fill="none"
    viewBox="0 0 34 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M33.2841 3.7563c-.3859-1.4813-1.5437-2.6438-3.0065-3.0375C27.632 0 17 0 17 0S6.368 0 3.7162.7188C2.2534 1.1125 1.1018 2.275.7096 3.7563 0 6.4375 0 12.025 0 12.025s0 5.5875.7096 8.2688c.3922 1.475 1.5438 2.5937 3.0066 2.9874C6.368 24 17 24 17 24s10.632 0 13.2838-.7188c1.4628-.3937 2.6144-1.5124 3.0066-2.9874C34 17.6125 34 12.025 34 12.025s0-5.5875-.7096-8.2687zM13.5203 17.1V6.95l8.8828 5.075z"
    />
  </svg>
);
export default YoutubeBlack;
